import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../api/client'

/**
 * RESULTADOS de la encuesta del evento — página pública por link SECRETO
 * (para compartir con el equipo/socios sin darles login de LGR). Muestra el
 * agregado + cada respuesta con nombre, SIN emails (dato personal; el detalle
 * completo vive en LGR). Se refresca sola cada 60 s.
 */

const INK = '#111'
const VERDE = '#2D6A3F'

const CHIP_LABEL = {
  curaduria: 'Curaduría de bodegas y vinos',
  ambientacion: 'Ambientación y producción',
  staff: 'Atención del staff',
  qr: 'Degustación con QR',
  otro: 'Otro',
}
const RECO_LABEL = { si_seguro: 'Sí, seguro', probablemente: 'Probablemente', no_seguro: 'No estoy seguro' }
const VOLV_LABEL = { si: 'Sí', tal_vez: 'Tal vez', no: 'No' }

function Barra({ label, n, total }) {
  const pct = total > 0 ? Math.round((n * 100) / total) : 0
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.82rem', color: '#444', marginBottom: 3 }}>
        <span>{label}</span><span style={{ fontWeight: 700 }}>{n} · {pct}%</span>
      </div>
      <div style={{ background: '#eee', borderRadius: 4, height: 10 }}>
        <div style={{ width: `${pct}%`, background: VERDE, height: 10, borderRadius: 4 }} />
      </div>
    </div>
  )
}

function Kpi({ valor, label }) {
  return (
    <div style={{ flex: 1, minWidth: 120, textAlign: 'center', padding: '14px 8px', background: '#fff', border: '1px solid #e5e2da' }}>
      <p style={{ fontSize: '1.6rem', fontWeight: 700, color: INK, margin: 0 }}>{valor}</p>
      <p style={{ fontSize: '0.72rem', letterSpacing: 1, textTransform: 'uppercase', color: '#8a8578', margin: '4px 0 0' }}>{label}</p>
    </div>
  )
}

export default function ResultadosEncuestaEventoPage() {
  const { token } = useParams()
  const [datos, setDatos] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const cargar = () => api.get(`/publico/encuesta-evento-resultados/${token}`)
      .then(({ data }) => setDatos(data))
      .catch(() => setError('Este enlace no es válido.'))
    cargar()
    const t = setInterval(cargar, 60_000)
    return () => clearInterval(t)
  }, [token])

  if (error) return <div style={st.page}><div style={st.card}><p style={st.error}>{error}</p></div></div>
  if (!datos) return <div style={st.page}><div style={st.card}><p style={st.sub}>Cargando…</p></div></div>

  const total = datos.gusto.si + datos.gusto.no
  const pctSi = total > 0 ? Math.round((datos.gusto.si * 100) / total) : null
  const conTexto = datos.individuales.filter(i => i.comentario || i.no_gusto || i.le_gusto_otro)

  return (
    <div style={st.page}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={st.card}>
          <div style={st.logoWrap}><img src="/favicon.png" alt="Ligier" style={st.logoImg} /></div>
          <p style={st.eyebrow}>Ligier Experience N°8</p>
          <h1 style={st.h1}>Resultados de la encuesta</h1>
          <p style={st.sub}>Se actualiza sola a medida que llegan respuestas.</p>

          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 18 }}>
            <Kpi valor={`${datos.n} / ${datos.enviadas}`} label="Respondieron" />
            <Kpi valor={pctSi === null ? '—' : `${pctSi}%`} label="Les gustó" />
            <Kpi valor={datos.organizacion_promedio ?? '—'} label="Organización (1-5)" />
          </div>

          {Object.keys(datos.le_gusto || {}).length > 0 && (
            <div style={st.bloque}>
              <p style={st.bloqueTitulo}>Lo que más gustó</p>
              {Object.entries(datos.le_gusto).sort((a, b) => b[1] - a[1]).map(([k, n]) => (
                <Barra key={k} label={CHIP_LABEL[k] || k} n={n} total={datos.gusto.si || 1} />
              ))}
            </div>
          )}

          {Object.keys(datos.recomendarias || {}).length > 0 && (
            <div style={st.bloque}>
              <p style={st.bloqueTitulo}>¿Recomendarías Ligier Experience?</p>
              {['si_seguro', 'probablemente', 'no_seguro'].filter(k => datos.recomendarias[k]).map(k => (
                <Barra key={k} label={RECO_LABEL[k]} n={datos.recomendarias[k]} total={datos.gusto.si || 1} />
              ))}
            </div>
          )}

          {Object.keys(datos.volverias || {}).length > 0 && (
            <div style={st.bloque}>
              <p style={st.bloqueTitulo}>Los que no la pasaron bien — ¿volverían?</p>
              {['si', 'tal_vez', 'no'].filter(k => datos.volverias[k]).map(k => (
                <Barra key={k} label={VOLV_LABEL[k]} n={datos.volverias[k]} total={datos.gusto.no || 1} />
              ))}
            </div>
          )}

          {conTexto.length > 0 && (
            <div style={st.bloque}>
              <p style={st.bloqueTitulo}>Comentarios ({conTexto.length})</p>
              {conTexto.map((i, n) => (
                <div key={n} style={st.comentario}>
                  <p style={{ margin: 0, fontSize: '0.8rem', color: '#8a8578' }}>
                    {i.nombre || 'Asistente'} · {i.gusto === 'si' ? '👍 le gustó' : '👎 no le gustó'}
                    {i.organizacion ? ` · organización ${i.organizacion}/5` : ''}
                  </p>
                  {i.no_gusto && <p style={st.textoCom}>Lo que menos gustó: “{i.no_gusto}”</p>}
                  {i.le_gusto_otro && <p style={st.textoCom}>Otro destacado: “{i.le_gusto_otro}”</p>}
                  {i.comentario && <p style={st.textoCom}>“{i.comentario}”</p>}
                </div>
              ))}
            </div>
          )}

          <div style={st.bloque}>
            <p style={st.bloqueTitulo}>Todas las respuestas ({datos.individuales.length})</p>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                <thead>
                  <tr style={{ textAlign: 'left', color: '#8a8578', textTransform: 'uppercase', fontSize: '0.68rem', letterSpacing: 1 }}>
                    <th style={st.th}>Asistente</th><th style={st.th}>¿Le gustó?</th><th style={st.th}>Org.</th><th style={st.th}>Cierre</th>
                  </tr>
                </thead>
                <tbody>
                  {datos.individuales.map((i, n) => (
                    <tr key={n} style={{ borderTop: '1px solid #eee' }}>
                      <td style={st.td}>{i.nombre || '—'}</td>
                      <td style={st.td}>{i.gusto === 'si' ? 'Sí' : i.gusto === 'no' ? 'No' : '—'}</td>
                      <td style={st.td}>{i.organizacion ? `${i.organizacion}/5` : '—'}</td>
                      <td style={st.td}>{RECO_LABEL[i.recomendarias] || VOLV_LABEL[i.volverias] || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <p style={st.legal}>Vinoteca Ligier · resultados en vivo · sin datos de contacto</p>
      </div>
    </div>
  )
}

const st = {
  page: { minHeight: '100vh', background: '#f4f1ec', padding: '24px 12px', fontFamily: 'Arial, Helvetica, sans-serif' },
  card: { background: '#fff', padding: '26px 22px 30px' },
  logoWrap: { textAlign: 'center', borderBottom: `3px solid ${VERDE}`, paddingBottom: 14, marginBottom: 20 },
  logoImg: { width: 110, height: 'auto', display: 'inline-block' },
  eyebrow: { textAlign: 'center', fontSize: '0.7rem', letterSpacing: 2, textTransform: 'uppercase', color: '#8a8578', margin: 0 },
  h1: { textAlign: 'center', fontSize: '1.35rem', fontWeight: 700, color: INK, margin: '8px 0 4px', lineHeight: 1.3 },
  sub: { textAlign: 'center', fontSize: '0.85rem', color: '#666', margin: '0 0 8px' },
  bloque: { borderTop: '1px solid #eee', marginTop: 22, paddingTop: 16 },
  bloqueTitulo: { fontSize: '0.8rem', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#333', margin: '0 0 12px' },
  comentario: { background: '#faf9f6', border: '1px solid #eee', padding: '10px 12px', marginBottom: 8 },
  textoCom: { margin: '6px 0 0', fontSize: '0.88rem', color: '#222', lineHeight: 1.5 },
  th: { padding: '6px 8px' },
  td: { padding: '7px 8px', color: '#222' },
  error: { textAlign: 'center', color: '#991b1b', fontSize: '0.9rem', margin: '12px 0' },
  legal: { textAlign: 'center', fontSize: '0.72rem', color: '#9ca3af', margin: '18px 8px 0' },
}
